import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GameCategoryService} from "../../services/game-category.service";
import {OrganizationGameCategoryData} from "../../interfaces/organization-game-category-data";
import {Overlayable} from "../../interfaces/overlayable";
import {Observable, take} from "rxjs";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {GameCategoriesSelectorMode} from "../../ts-types/game-categories-selector-mode";
import {EGame} from "../../enums/game";
import {TimerButtonState} from "../../enums/timer-button-state";
import {DataService} from "../../services/data.service";
import {StudentAuthService} from "../../services/student-auth.service";
import {TimerButtonService} from "../../services/timer-button.service";

@UntilDestroy({checkProperties: true})
@Component({
  selector: 'brt-game-categories-selector',
  templateUrl: './game-categories-selector.component.html',
  styleUrls: ['./game-categories-selector.component.scss']
})
export class GameCategoriesSelectorComponent implements OnInit, Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  @Input('selectCallback') selectCallback?: (catId: number) => void = undefined;
  @Input('currentStateListener') set setCurrentStateListener(listener: Observable<number[]>) {
    listener.pipe(untilDestroyed(this)).subscribe((val) => {
      this.currentSelection = val;
    })
  }

  @Input('isTraining') set setIsTraining(val: boolean) {
    this.isGlobalTraining = val;
    this.hasGlobalTrainingFirstResponse = true;
  }

  @Input('mode') mode: GameCategoriesSelectorMode = "teacher";
  @Input('gameId') gameId!: EGame;
  @Input('data') set setOrganizationData(data: OrganizationGameCategoryData) {
    this.organizationData = data;

    console.warn("Mapped data from server: ");
    // console.log(data);

    // this.currentSelection = this.organizationData.items.map(item => item.categoryData.id);
  }

  organizationData?: OrganizationGameCategoryData;
  currentSelection: number[] = [];

  isGlobalTraining = false;
  hasGlobalTrainingFirstResponse = false;

  constructor(private gameCategoryService: GameCategoryService, private data: DataService, private studentAuthService: StudentAuthService, private timerService: TimerButtonService) {
  }

  ngOnInit() {
    // this.gameCategoryService.loadOrganizationGameCategoryData('asdasd').then((response) => {
    //   this.organizationData = response;
    // });

    if(!this.hasGlobalTrainingFirstResponse) {
      this.data.getGameTimer(this.studentAuthService.getClassData().id).pipe(take(1)).subscribe((response) => {
        console.log(response);
        this.isGlobalTraining = response === false;
        this.hasGlobalTrainingFirstResponse = true;
        // Then wait for possible timer updates and update banner according to new state
      })
    }

    this.timerService.onUpdate().pipe(untilDestroyed(this)).subscribe((newState) => {
      this.isGlobalTraining = newState.state !== TimerButtonState.PLAY;
    })
  }

  onSelectChange($event: number) {
    if(this.selectCallback) {
      this.selectCallback($event);
    }
  }

  isSelected(catId: number): boolean {
    return this.currentSelection.indexOf(catId) !== -1;
  }
}
